import { render, staticRenderFns } from "./announcementOfManagementAddEdit.vue?vue&type=template&id=632fe1df&scoped=true"
import script from "./announcementOfManagementAddEdit.vue?vue&type=script&lang=js"
export * from "./announcementOfManagementAddEdit.vue?vue&type=script&lang=js"
import style0 from "./announcementOfManagementAddEdit.vue?vue&type=style&index=0&id=632fe1df&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632fe1df",
  null
  
)

export default component.exports